// i18n 默认资源 + 初始化
//
// 职责：
//   1. 内置本地 common 翻译资源（zh-CN / en-US），以 JS 对象形式打包进 SDK（等价 JSON）
//   2. 注册到 ttx.lang 引擎
//   3. 检测初始语言（URL ?lang= > localStorage > navigator.language > 默认 zh-CN）
//   4. 应用初始语言
//
// 后续线上 JSON 加载：
//   ttx.lang.loadLocale('/locales/en-US/biz.json', 'en-US').then(...)
//
// 依赖：本文件必须在 tx.lang.js 之后执行（入口 index.js 中 import 顺序保证）
window.ttx = window.ttx || {};

(function () {
    // ── 内置本地 common 翻译资源 ─────────────────────────────────────
    // 语义等同 JSON，用 JS 对象以避免引入 rollup json 插件
    var zhCN = {
        'common.ok': '确定',
        'common.cancel': '取消',
        'common.save': '保存',
        'common.delete': '删除',
        'common.edit': '编辑',
        'common.add': '新增',
        'common.confirm': '确认',
        'common.tip': '提示',
        'common.close': '关闭',
        'common.fullscreen': '全屏',
        'common.exitFullscreen': '退出全屏',
        'common.empty': '暂无内容',
        'common.noData': '暂无数据',
        'common.loading': '加载中...',
        'common.search': '查询',
        'common.reset': '重置',
        'common.export': '导出',
        'common.import': '导入',
        'common.refresh': '刷新',
        'common.back': '返回',
        'common.more': '更多',
        'common.yes': '是',
        'common.no': '否',
        'common.success': '操作成功',
        'common.failed': '操作失败',
        'common.hello': '你好，{name}',
        'common.tip.delete': '确定要删除吗？',
        'common.tip.save': '数据已修改，确定不保存吗？'
    };

    var enUS = {
        'common.ok': 'OK',
        'common.cancel': 'Cancel',
        'common.save': 'Save',
        'common.delete': 'Delete',
        'common.edit': 'Edit',
        'common.add': 'Add',
        'common.confirm': 'Confirm',
        'common.tip': 'Tip',
        'common.close': 'Close',
        'common.fullscreen': 'Fullscreen',
        'common.exitFullscreen': 'Exit Fullscreen',
        'common.empty': 'No content',
        'common.noData': 'No data',
        'common.loading': 'Loading...',
        'common.search': 'Search',
        'common.reset': 'Reset',
        'common.export': 'Export',
        'common.import': 'Import',
        'common.refresh': 'Refresh',
        'common.back': 'Back',
        'common.more': 'More',
        'common.yes': 'Yes',
        'common.no': 'No',
        'common.success': 'Operation succeeded',
        'common.failed': 'Operation failed',
        'common.hello': 'Hello, {name}',
        'common.tip.delete': 'Are you sure to delete?',
        'common.tip.save': 'Data has been modified. Discard changes?'
    };

    // 注册到引擎
    ttx.lang.registerResources({
        'zh-CN': zhCN,
        'en-US': enUS
    });

    // ── 初始语言检测 ─────────────────────────────────────────────────
    // 优先级：URL ?lang= > localStorage > navigator.language > 默认 zh-CN
    function detectLang() {
        // 优先级 1：URL 查询参数 ?lang=en-US
        try {
            var params = new URLSearchParams(window.location.search);
            var urlLang = params.get('lang');
            if (urlLang) return urlLang;
        } catch (e) {
            // URLSearchParams 不可用时降级
        }

        // 优先级 2：localStorage 持久化的偏好
        try {
            var savedLang = localStorage.getItem('ttx-lang');
            if (savedLang) return savedLang;
        } catch (e) {
            // localStorage 不可用时降级
        }

        // 优先级 3：浏览器语言
        if (navigator.language) {
            var navLang = navigator.language;
            // navigator.language 可能返回 'zh' / 'zh-CN' / 'en' / 'en-US'
            // 只在已注册的语言中匹配，否则回退默认
            if (navLang === 'zh-CN' || navLang === 'zh') return 'zh-CN';
            if (navLang === 'en-US' || navLang === 'en') return 'en-US';
        }

        // 优先级 4：默认中文
        return 'zh-CN';
    }

    // 应用初始语言
    var initialLang = detectLang();
    if (initialLang !== ttx.lang.getLang()) {
        ttx.lang.setLang(initialLang);
    }
})();
